import NorthEastIcon from '@mui/icons-material/NorthEast';
import { CREATORS_PAGE_ROUTE_ID, PUBLISHERS_PAGE_ROUTE_ID, FAQ_ROUTE_ID, TERMS_OF_SERVICE_ROUTE_ID, COOKIE_POLICY_ROUTE_ID, PRIVACY_POLICY_ROUTE_ID, } from 'root/src/shared/descriptions/routes/routeIds';
import { EMAIL } from 'root/src/shared/constants/pageData';
import Link from 'root/src/client/web/base/Link';
import { RedesignLogo } from 'root/src/client/v2/layout/components/RedesignLogo';
// Real destinations mirror the legacy footer module (src/shared/descriptions/modules/newFooter.js).
const DISCORD_URL = 'https://discord.gg/xmECwRu';
const ABOUT_US_PATH = '/about-us'; // webflow page, full navigation
const PRESS_KIT_PATH = '/files/Dare_Drop_Brand_Kit.pdf';
const FOOTER_COLUMNS = [
    {
        category: 'Platform',
        links: [
            { label: 'For Creators', routeId: CREATORS_PAGE_ROUTE_ID },
            { label: 'For Publishers', routeId: PUBLISHERS_PAGE_ROUTE_ID },
            { label: 'FAQ', routeId: FAQ_ROUTE_ID },
        ],
    },
    {
        category: 'Company',
        links: [
            { label: 'About Us', href: ABOUT_US_PATH },
            { label: 'Contact Us', email: EMAIL },
            { label: 'Get Press Kit', download: PRESS_KIT_PATH },
        ],
    },
    {
        category: 'Legal',
        links: [
            { label: 'Terms of Service', routeId: TERMS_OF_SERVICE_ROUTE_ID },
            { label: 'Cookie Policy', routeId: COOKIE_POLICY_ROUTE_ID },
            { label: 'Privacy Policy', routeId: PRIVACY_POLICY_ROUTE_ID },
        ],
    },
];
const footerLinkClass = 'text-sm text-muted-foreground no-underline transition-colors hover:text-foreground';
const FooterLinkItem = ({ link }) => {
    if ('routeId' in link) {
        return <Link routeId={link.routeId} className={footerLinkClass}>{link.label}</Link>;
    }
    if ('email' in link) {
        return <a href={`mailto:${link.email}`} className={footerLinkClass}>{link.label}</a>;
    }
    if ('download' in link) {
        return <a href={link.download} download target="_blank" rel="noreferrer" className={footerLinkClass}>{link.label}</a>;
    }
    return <a href={link.href} className={footerLinkClass}>{link.label}</a>;
};
export const RedesignFooter = () => {
    const year = new Date().getFullYear();
    return (<footer className="redesign px-4 pb-6 pt-14 sm:px-6 lg:px-8">
			<div className="relative mx-auto max-w-7xl overflow-hidden rounded-xl border border-solid border-white/[0.06] bg-card p-8 sm:p-10">
				<div className="absolute inset-x-0 top-0 h-[2px] bg-gradient-mixed"/>

				<div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-start">
					<div className="max-w-sm">
						<RedesignLogo />
						<p className="mt-3 text-sm leading-relaxed text-muted-foreground">
							The platform connecting game creators, publishers, and passionate gaming communities.
						</p>
					</div>

					<a href={DISCORD_URL} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2 rounded-lg bg-[#5865F2] px-4 py-2 text-sm font-medium text-white no-underline transition-opacity hover:opacity-90">
						<svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
							<path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/>
						</svg>
						Join Discord
						<NorthEastIcon sx={{ fontSize: 14 }} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"/>
					</a>
				</div>

				<div className="my-8 h-px bg-white/[0.06]"/>

				<div className="grid gap-8 sm:grid-cols-3">
					{FOOTER_COLUMNS.map(column => (<div key={column.category}>
							<h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{column.category}</h3>
							<ul className="mt-3 flex flex-col gap-2.5" role="list">
								{column.links.map(link => (<li key={link.label}><FooterLinkItem link={link}/></li>))}
							</ul>
						</div>))}
				</div>

				<div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-solid border-white/[0.06] pt-5 sm:flex-row">
					<p className="text-xs text-muted-foreground">&copy; {year} Dare Drop. All rights reserved.</p>
					<div className="flex items-center gap-5">
						<Link routeId={PRIVACY_POLICY_ROUTE_ID} className="text-xs text-muted-foreground no-underline transition-colors hover:text-foreground">Privacy</Link>
						<Link routeId={TERMS_OF_SERVICE_ROUTE_ID} className="text-xs text-muted-foreground no-underline transition-colors hover:text-foreground">Terms</Link>
					</div>
				</div>
			</div>
		</footer>);
};
